import { APIResponse } from "../model/APIResponse";
import { APIRequest } from "../model/APIRequest";
import { DTORequest } from "../model/DTORequest";
import axiosInstance from "../core/AxiosInstance";

export class APIService {
    /**
     *
     */
    private url: string = ""
    constructor(private _url: string) {
        this.url = _url
    }

    async auth(dtoRequest: DTORequest) {
        let apiResponse: APIResponse
        return await axiosInstance.post<APIResponse>(`${this.url}/api/matiga/pesowifi/auth`, dtoRequest)
            .then(response => {
                return response.data
            })
            .catch(error => {
                apiResponse = {
                    errorCode: 1,
                    msg: error
                }
                return apiResponse
            });
    }

    async clientRecord(dtoRequest: DTORequest) {
        let apiResponse: APIResponse

        return await axiosInstance.post<APIResponse>(`${this.url}/api/matiga/pesowifi/client-record`, dtoRequest)
            .then(response => {
                return response.data
            })
            .catch(error => {
                apiResponse = {
                    errorCode: 1,
                    msg: error
                }
                return apiResponse
            });
    }

    async pause(apiRequest: APIRequest) {
        let apiResponse: APIResponse

        return await axiosInstance.get<APIResponse>(`${this.url}/pause?clientmac=${encodeURIComponent(apiRequest.clientMac)}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                apiResponse = {
                    errorCode: 1,
                    msg: error
                }
                return apiResponse
            });
    }

    async claimVoucher(voucherCode: string) {
        let apiRequest: APIRequest = {
            clientMac: localStorage.getItem("clientMac") || "",
            apMac: localStorage.getItem("apMac") || "",
            ssidName: localStorage.getItem("ssidName") || "",
            radioId: Number(localStorage.getItem("radioId")) || 0,
            site: localStorage.getItem("site") || "",
            authType: 3,
            voucherCode: voucherCode
        }
        let apiResponse: APIResponse

        return await axiosInstance.post<APIResponse>(`${this.url}/api/matiga/pesowifi/claim-voucher`, apiRequest)
            .then(response => {
                return response.data
            })
            .catch(error => {
                apiResponse = {
                    errorCode: 1,
                    msg: error
                }
                return apiResponse
            });
    }

    async getMachinesInformation() {
        let apiResponse: APIResponse

        return await axiosInstance.get<APIResponse>(`${this.url}/api/matiga/pesowifi/machine/getlist`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                apiResponse = {
                    errorCode: 1,
                    msg: error
                }
                return apiResponse
            });
    }
}